/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Field, FormikProvider, useFormik } from 'formik';
import { AxiosError } from 'axios';
import FieldInputText from '../../common/FieldInputText';
import { useDispatch, useSelector } from 'react-redux';
import { ResetPassword, VerifyPasswordLink } from '../../../redux/features/auth/authActions';
import { errorMessage } from '../../../utlis/common';
import { MESSAGES } from '../../../utlis/messages';
import SubmitButton from '../../common/SubmitButton';

export function ChangePassword() {
    const [showPassword, setShowPassword] = useState(true);
    const [showConfirmPassword, setShowConfirmPassword] = useState(true);
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id') || '';
    const otp = searchParams.get('otp') || null;

    const dispatch: any = useDispatch()
    const navigate = useNavigate();
    const authState = useSelector((state: any) => state.auth);
    const resetPasswordSlice = useSelector((state: any) => state.resetPasswordSlice)


    useEffect(() => {
        if (id && otp) { dispatch(VerifyPasswordLink({ id, otp, navigate })) }
        else {
            errorMessage(MESSAGES.INVALID_CHANGE_PASSWORD_LINK)
            navigate('/auth/forgot-password')
        }
    }, [id]);


    const initialValues = {
        password: '',
        confirmPassword: '',
    };

    const changePasswordSchema = Yup.object().shape({
        password: Yup.string()
            .required(MESSAGES.PASSWORD_REQUIRED)
            .min(8, MESSAGES.PASSWORD_SHOULD_8_CHARACTERS)
            .matches(/[A-Z]/, MESSAGES.ONE_UPPERCASE_LETTER_REQUIRED)
            .matches(/[a-z]/, MESSAGES.ONE_LOWERCASE_LETTER_REQUIRED)
            .matches(/[0-9]/, MESSAGES.ONE_NUMBER_REQUIRED)
            .matches(/[@#%!-]/, MESSAGES.ONE_SPECIAL_CHARACTER_REQUIRED),
        confirmPassword: Yup.string()
            .required(MESSAGES.PLEASE_CONFIRM_PASSWORD)
            .oneOf([Yup.ref('password')],MESSAGES.PASSWORD_MUST_MATCH),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: changePasswordSchema,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            values['email'] = authState.email;
            dispatch(ResetPassword({ values, navigate }))
        },
    });

    return (
        <FormikProvider value={formik}>
            <form
                className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
                noValidate
                id="kt_login_password_reset_form"
                onSubmit={formik.handleSubmit}
            >
                <div className="text-center mb-10">
                    <h1 className="text-dark fw-bolder mb-3">{MESSAGES.SET_NEW_PASSWORD}</h1>
                    <div className="text-gray-500 fw-semibold fs-6">
                        {MESSAGES.PASSWORD_COMBINATION}
                    </div>
                </div>

                <div className="fv-row mb-3">
                    <div className="position-relative">
                        <Field
                            name="password"
                            validate={changePasswordSchema}
                            label="Password"
                            type={showPassword ? 'password' : 'text'}
                            required={true}
                            component={FieldInputText}
                            placeholder="Password"
                        />

                        <i
                            className={showPassword ? 'bi bi-eye-slash-fill eyeIcon' : 'bi bi-eye-fill eyeIcon'}
                            onClick={() => setShowPassword(!showPassword)}
                        ></i>
                    </div>

                </div>

                <div className="fv-row mb-3">
                    <div className="position-relative">
                        <Field
                            name="confirmPassword"
                            validate={showConfirmPassword}
                            label="Conferma Password"
                            type={showConfirmPassword ? 'password' : 'text'}
                            required={true}
                            component={FieldInputText}
                            placeholder="Conferma Password"
                        />

                        <i
                            className={
                                showConfirmPassword ? 'bi bi-eye-slash-fill eyeIcon' : 'bi bi-eye-fill eyeIcon'
                            }
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        ></i>
                    </div>

                </div>

                <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                    <SubmitButton title="Invia" type='submit' loading={resetPasswordSlice?.loading} />
                    <Link to="/auth/login">
                        <button type="button" className="btn btn-light">
                            {MESSAGES.CANCEL}
                        </button>
                    </Link>
                </div>
            </form>
        </FormikProvider>
    );
}
